import { useState } from 'react'
import { useField } from 'formik'
import {
    IconButton,
    FormControl,
    FormHelperText,
    OutlinedInput,
    InputAdornment,
    InputLabel
} from '@mui/material'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Trans } from 'react-i18next';

export default (props) => {
    const {
        disabled,
        extraLabel = ' ',
        label,
        maxLength = 256,
        min = 1,
        max = 9999999999999999n,
        password,
        placeholder,
        requiredField,
        rows,
        showPercentage,
        showPrice,
        noHelperText,
        showTitle,
        mask,
        replacement,
        type = 'text',
        readOnly= false,
        unitMeasurementEnd= '',
        unitMeasurementStart= '',
        fullWidth=false,
        options=[],
        i18n=false,
        ...rest
    } = props
    const [field, meta] = useField(props)
    const { error } = meta
    const isError = !!error
    const [showPassword, setShowPassword] = useState(false)
    const select = options.length > 0

    const renderHelperText = () => {
        if (isError && i18n) {
            return <Trans i18nKey={error}></Trans>
        } else if (isError) {
            return error
        } else if (extraLabel !== ' ' && i18n) {
            return <Trans i18nKey={extraLabel}></Trans>
        } else return extraLabel
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    }

    const renderEndAdornment = () => {
        if (password) {
            return (
                <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword}>
                        {showPassword ? (
                            <VisibilityOff />
                        ) : (
                            <Visibility />
                        )}
                    </IconButton>
                </InputAdornment>
            )
        } else {
            return
        }
    }

    const renderStartAdornment = () => {
        if (showPrice) {
            return <InputAdornment position="start">$</InputAdornment>
        } else if (unitMeasurementStart){
            return <InputAdornment position="start">{unitMeasurementStart}</InputAdornment>
        } else {
            return
        }
    }

    const renderSelect = () => {
        return <Select autoWidth {...field}>
            {options.map(option => <MenuItem value={option.value} key={option.key}>{option.value}</MenuItem>)}
        </Select>
    }

    return (
        <FormControl fullWidth={fullWidth}>
            {label && (
                <InputLabel>
                    <Trans i18nKey={label}></Trans>{requiredField && `*`}
                </InputLabel>
            )}
            { select && renderSelect()}
            { !select && <OutlinedInput
                {...field}
                title={disabled && showTitle ? field?.value : ''}
                multiline={!!rows}
                rows={rows}
                error={isError}
                placeholder={placeholder}
                inputProps={type === 'number' ? { readOnly, min, max }: {readOnly, maxLength}}
                type={!password || showPassword ? type : 'password'}
                disabled={disabled}
                endAdornment={renderEndAdornment()}
                startAdornment={renderStartAdornment()}
                {...rest}
            />}
            {!noHelperText && (
                <FormHelperText>
                    {renderHelperText()}
                </FormHelperText>
            )}
        </FormControl>
    )
}